import React, { createContext, useReducer, Dispatch } from "react";
import {
  baseReducer,
  BaseActions,
  BaseTypes,
  CampusCategoriesConfig,
  InstitutionThemePreferences,
} from "./base.reducer";

export type InitialStateType = {
  base: BaseTypes;
};

export const defaultGroupInLinkRestriction = {
  enabled: false,
  groups_allowed: 1,
};

export const defaultBookingClassroomOrder = [
  {
    field: "capacity",
    direction: "ASC",
  },
];

export const defaultCampusCategoriesConfig: CampusCategoriesConfig = {
  enabled: false,
  campus_categories: [],
};

export const defaultRestrictionConfigurations = {
  enabled: false,
  loaded: false,
  fields: {
    groups: [],
  },
};

export const defaultInstitutionThemePreferences: InstitutionThemePreferences = {
  enabled: false,
  institution: null,
  assets: null,
};

export const initialState: InitialStateType = {
  base: {
    settings: null,
    isMouseflowEnabled: false,
    isGroupManagerFilterEnabled: true,
    createGroupWithinLinkCreation: "DISABLED",
    groupsInLinkRestriction: defaultGroupInLinkRestriction,
    bookingClassroomOrder: defaultBookingClassroomOrder,
    campusCategoriesConfig: defaultCampusCategoriesConfig,
    canCreateLinkWithoutNewSections: false,
    bookingsProgramRequired: "HIDDEN",
    base: null,
    locale: (window?.localStorage?.getItem("locale") ?? "es") as "es" | "en",
    restrictionConfigurations: defaultRestrictionConfigurations,
    institutionThemePreferences: structuredClone(defaultInstitutionThemePreferences),
    groupsManagerType: "SHARED",
    schedulerEditorClearLinkResources: null,
  },
};

const ContextEDH = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<BaseActions | void>;
}>({
  state: initialState,
  dispatch: () => null,
});

const mainReducer = ({ base }: InitialStateType, action: any) => ({
  base: baseReducer(base, action),
});

const ContextEDHProvider: React.FC<{ children?: React.ReactNode | undefined }> = ({ children }) => {
  const [state, dispatch] = useReducer(mainReducer, initialState);

  return <ContextEDH.Provider value={{ state, dispatch }}>{children}</ContextEDH.Provider>;
};

export { ContextEDHProvider, ContextEDH };
